// GENERATED by scripts/refresh-host-rpc-names.mjs — do not edit by hand.
//
// The registered host RPC surface WITH ITS SIGNATURES, snapshotted 2026-11-03
// from giraffe-four/libs/gi-js at 579d960a5 (committed 2026-11-03).
// Provenance: VERIFIED AGAINST THE CURRENT BUILD. Not documented, and NOT A
// CONTRACT — an unpromised internal can move in any release with no changelog.
// See CLAUDE.md > Do / do not.
//
// WHY SIGNATURES AND NOT JUST NAMES: a host call is positional and untyped
// through `rpc.invoke`, so a wrong guess does not produce a diagnosable
// error — some host functions FAIL SOFT (`createRawSections` returns an empty
// array on rejection rather than throwing) and `InvocationError` seals
// `procedureName`, `cause` and `previousRejectReasons`. A bad guess yields a
// plausible-looking empty result with the explaining exception sealed. These
// signatures are what `giraffe_sdk_describe` serves so the guess is not made.
//
// `type` and `returns` are ANNOTATION TEXT, verbatim. An unannotated return
// reads "unknown" rather than a type inferred from the body. `facts` are
// syntactic reads of the body, never a type.
//
// Refresh with: yarn rpc:refresh
//
// 194 signatures.

/**
 * Which host build this snapshot speaks for. A name absent here is absent
 * from THIS commit, which is all a snapshot can say (#39).
 */
export const HOST_RPC_SNAPSHOT = {
  commit: "579d960a5",
  committedAt: "2026-11-03",
  takenAt: "2026-11-03",
} as const;

/** One parameter of a host RPC, as declared. */
export type HostRpcParam = {
  readonly name: string;
  /** The annotation text, verbatim. "unknown" when the declaration has none. */
  readonly type: string;
  readonly optional: boolean;
  readonly hasDefault: boolean;
};

/** One host RPC procedure, as declared. */
export type HostRpcSignature = {
  readonly name: string;
  readonly params: readonly HostRpcParam[];
  /** The annotation text, verbatim. "unknown" when the declaration has none. */
  readonly returns: string;
  /** The host team's own JSDoc, flattened to one line. Null when there is none. */
  readonly doc: string | null;
  /**
   * Read off the declaration's body by rpc:refresh (scripts/host-source.mjs
   * bodyFacts). Syntactic, not a type: see that function for what each misses.
   */
  readonly facts: { readonly returnsNothing: boolean; readonly asksUser: boolean };
};

const SIGNATURES: readonly HostRpcSignature[] = [
  {
    name: "activateDrawingLayer",
    params: [{ name: "layerNameOrId", type: "string", optional: true, hasDefault: false }],
    returns: "unknown",
    doc: "The active drawing layer is the layer that any new geometry will be added to. If layerNameOrId is not passed, Giraffe will select the default drawing layer (same as when opening the project).",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "activateLensLayer",
    params: [
      { name: "layerNameOrId", type: "string", optional: false, hasDefault: false },
      {
        name: "overrides",
        type: "Partial<GiraffeLensableStyle>",
        optional: true,
        hasDefault: false,
      },
      { name: "uiOverrides", type: "Partial<LensUiState>", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Activate the lens for a layer.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "activateScenario",
    params: [{ name: "scenarioId", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Activate a scenario, making it the current working scenario.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "activateViewLayers",
    params: [{ name: "vista", type: "Vista", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Activate the layers of a view's layerTree and updates the sun position.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "addContentPackToProject",
    params: [{ name: "id", type: "number", optional: false, hasDefault: false }],
    returns: "Promise<{\n  contents: PackContents;\n  mergeDecisions?: MergeDecisions;\n}>",
    doc: "Fetches the content pack specified by `id` and imports everything in it into the current project. To bring in only part of a pack, read its contents with {@link fetchPackContents} and apply the pieces you want with the matching SDK function: | Pack contents | Apply with | | --- | --- | | `layers` | {@link addLayerToProject} | | `usages` | {@link createUsage} | | `flows` | {@link addFlow} | | `b...",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "addFlow",
    params: [{ name: "flow", type: "GiraffeNodeGraph", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: 'Adds a flow to the project. A flow is a node graph where each node has a `type` which is the **GUID** of a node definition. See all available node types at: <a href="/md/nodes.md">/md/nodes.md</a>',
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "addFlowDag",
    params: [{ name: "dag", type: "GiraffeNodeGraph", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: null,
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "addHtmlPopup",
    params: [
      { name: "html", type: "string", optional: false, hasDefault: false },
      { name: "lngLat", type: "LngLatLike", optional: false, hasDefault: false },
      { name: "options", type: "PopupOptions", optional: false, hasDefault: false },
      { name: "openOverBottomBarContent", type: "unknown", optional: false, hasDefault: true },
    ],
    returns: "unknown",
    doc: "Add an HTML popup to the map at a specific location.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "addIframePopup",
    params: [
      { name: "url", type: "string", optional: false, hasDefault: false },
      { name: "lngLat", type: "LngLatLike", optional: false, hasDefault: false },
      { name: "options", type: "PopupOptions", optional: false, hasDefault: false },
      { name: "width", type: "unknown", optional: false, hasDefault: true },
      { name: "height", type: "unknown", optional: false, hasDefault: true },
      { name: "openOverBottomBarContent", type: "unknown", optional: false, hasDefault: true },
    ],
    returns: "unknown",
    doc: "LngLatLike and PopupOptions are mapbox gl types",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "addLayerToProject",
    params: [{ name: "layerId", type: "string | number", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Add the layer to the project. Layer must already exist see `createLayer`.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "addMapboxEventListener",
    params: [
      { name: "eventType", type: "keyof MapEvents", optional: false, hasDefault: false },
      { name: "debounceTime", type: "unknown", optional: false, hasDefault: true },
      { name: "layerIds", type: "string | string[]", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "add a listener to mapbox events. See Mapbox docs for options",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "addProjectLayer",
    params: [
      { name: "layer", type: "{ id: string | number }", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: null,
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "addTempLayer",
    params: [
      { name: "layerName", type: "string", optional: false, hasDefault: false },
      { name: "style", type: "MapboxStyleLayer", optional: true, hasDefault: false },
      { name: "lens", type: "GiraffeLensableStyle", optional: true, hasDefault: false },
      { name: "hideInTree", type: "unknown", optional: false, hasDefault: true },
      { name: "opacity", type: "number", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "add (or update the style of) a temporary (exists only for the current session/client) layer with a tiled source NB the source cannot be updated once the layer has been added, but the style can. To update the source, remove the layer and re-add it.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "addTempLayerGeoJSON",
    params: [
      { name: "name", type: "string", optional: false, hasDefault: false },
      { name: "fc", type: "FeatureCollection", optional: false, hasDefault: false },
      { name: "style", type: "Partial<MapboxStyleLayer>", optional: false, hasDefault: true },
      { name: "lens", type: "GiraffeLensableStyle", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "add a temporary (exists only for the current session/client) layer with GeoJSON data source",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "bulkCreateProjects",
    params: [
      {
        name: "projects",
        type: "{\n      feature: Feature<Point | Polygon | MultiPolygon>;\n      overrides?: ProjectOverrides;\n      templateId?: ProjectId;\n    }[]",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "Promise<(number | null)[]>",
    doc: "Bulk-create projects from an array of boundary features, each with optional per-project overrides. Mirrors {@link createProject} for many projects at once, delegating to `workspaceStateManager.bulkCreateProjects`. Every feature/overrides pair is validated up-front, so nothing is created if any pair is invalid. Only available to approved apps. Contact us for details.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "changeLayerOpacity",
    params: [
      { name: "layerId", type: "string", optional: false, hasDefault: false },
      { name: "opacity", type: "number", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Change the opacity of a layer. layerId is the id of the layer, or the layer name. Opacity is a number between 0 and 1.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "changeLayerVisibility",
    params: [
      { name: "layerId", type: "string", optional: false, hasDefault: false },
      { name: "visible", type: "boolean", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Change the visibility of a layer. layerId is the id of the layer, or the layer name. Visible is a boolean.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "clearIsolatedFeatures",
    params: [],
    returns: "unknown",
    doc: "Clear the isolated features and disable isolate mode if it was enabled.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "clearSDKPopup",
    params: [],
    returns: "unknown",
    doc: "Clear/remove the current SDK popup from the map.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "closeAppPanel",
    params: [{ name: "options", type: "{ panelKey?: string }", optional: false, hasDefault: true }],
    returns: "unknown",
    doc: "Close a panel this app opened, or all of them.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "createApp",
    params: [{ name: "options", type: "CreateAppOptions", optional: false, hasDefault: false }],
    returns: "Promise<HostedApp>",
    doc: "Create a new app in the current workspace from a page of HTML. Inline your scripts and styles, or load them from absolute URLs. The workspace needs an active Enterprise license and app creation enabled, and you need edit access to it. You become the app's admin.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "createBlock",
    params: [{ name: "block", type: "BlockDefinition", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Adds a new block definition to the project",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "createDrawingLayer",
    params: [
      { name: "layerNameOrId", type: "string", optional: false, hasDefault: false },
      { name: "lock", type: "unknown", optional: false, hasDefault: true },
    ],
    returns: "unknown",
    doc: "Creates a new drawing layer with the given name. Optionally locks the layer.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "createGeoJSONLayer",
    params: [
      { name: "layerName", type: "string", optional: false, hasDefault: false },
      { name: "fc", type: "FeatureCollection", optional: false, hasDefault: false },
      { name: "layerMeta", type: "LayerConfigOptions", optional: true, hasDefault: false },
      { name: "lens", type: "GiraffeLensableStyle", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Create a new GeoJSON layer from the provided data.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "createLayer",
    params: [{ name: "layerPost", type: "LayerBundle", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Create a layer with full configuration options.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "createLayerGroup",
    params: [
      { name: "groupName", type: "string", optional: false, hasDefault: false },
      { name: "children", type: "string[]", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Create an empty group in the layer tree.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "createProject",
    params: [
      {
        name: "feature",
        type: "Feature<Point | Polygon | MultiPolygon>",
        optional: false,
        hasDefault: false,
      },
      { name: "overrides", type: "ProjectOverrides", optional: true, hasDefault: false },
      { name: "showDialog", type: "unknown", optional: false, hasDefault: true },
      { name: "templateId", type: "ProjectId", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Create a project from a boundary feature.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "createProjectAttachmentPrompt",
    params: [
      { name: "formats", type: "FileTypeSubstring[]", optional: true, hasDefault: false },
      { name: "projectId", type: "string", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Open a file picker dialog for the user to upload a new project attachment. Project attachments are files that are shared with a project.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "createRawSection",
    params: [
      {
        name: "feature",
        type: "Feature<Polygon | LineString | Point, Record<string, any> & { id?: never }>",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "string | undefined",
    doc: "create a Point, LineString or Polygon geometry that will be saved on Giraffe and that users can edit. Returns the id assigned to the created section, or `undefined` if creation was rejected (eg. insufficient permissions). NB. rate limited - do not call this unless there is a corresponding user action",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "createRawSections",
    params: [
      {
        name: "features",
        type: "Feature<Polygon | LineString | Point, Record<string, any> & { id?: never }>[]",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "string[]",
    doc: "Bulk method of createRawSection. Returns the ids assigned to the created sections (in the same order as the input), or an empty array if creation was rejected.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "createUsage",
    params: [
      { name: "usageName", type: "string", optional: false, hasDefault: false },
      { name: "usageDefinition", type: "Usage", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Create a new usage definition in the current project. `createUsage(usageName: string, usageDefinition: Usage): void`",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "deactivateLensLayer",
    params: [],
    returns: "unknown",
    doc: "Close the lens panel and deselect the current lens layer.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "deleteApp",
    params: [{ name: "id", type: "number", optional: false, hasDefault: false }],
    returns: "Promise<void>",
    doc: "Delete an app that Giraffe hosts in the current workspace. Nobody can open it afterwards.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "deleteBlock",
    params: [{ name: "blockId", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Removes a block definition from the project.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "deleteDrawingLayer",
    params: [{ name: "layerNameOrId", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Deletes a drawing layer and all associated sections.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "deleteFlow",
    params: [{ name: "id", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Removes a flow from the project.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "deleteFlowDag",
    params: [{ name: "id", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: null,
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "deleteProjectLayer",
    params: [{ name: "projectLayerId", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Removes a layer from the project",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "deleteRawSection",
    params: [{ name: "id", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Delete a raw section from the project.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "deleteRawSections",
    params: [
      { name: "ids", type: "string[]", optional: false, hasDefault: false },
      { name: "ignoreNotFound", type: "unknown", optional: false, hasDefault: true },
    ],
    returns: "unknown",
    doc: "Delete multiple raw sections from the project.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "deleteScenario",
    params: [
      { name: "scenario", type: "Scenario | Scenario[]", optional: false, hasDefault: false },
      { name: "onConfirm", type: "() => void", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Delete a scenario from the project.",
    facts: { returnsNothing: true, asksUser: true },
  },
  {
    name: "deleteUsage",
    params: [{ name: "usageName", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Delete a usage definition from the current project. `deleteUsage(usageName: string): void`",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "disableBottomBarIframe",
    params: [],
    returns: "unknown",
    doc: "Close the panel opened by enableBottomBarIframe.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "disableIsolateMode",
    params: [],
    returns: "unknown",
    doc: "Disables isolate mode.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "disableMapCamera",
    params: [],
    returns: "unknown",
    doc: "if called, the map camera will no longer be dispatched to the SDK app.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "disableMapContentEvents",
    params: [],
    returns: "unknown",
    doc: "if called, map content events (e.g. layer added, style updated, etc.) will no longer be dispatched to the SDK app.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "disableMapHover",
    params: [],
    returns: "unknown",
    doc: "if called, mouse coordinates will no longer be dispatched to the SDK app. (can help if performance is an issue)",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "disableSdkRender",
    params: [],
    returns: "unknown",
    doc: "Disable SDK-controlled rendering and restore features to their project state.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "drawPoint",
    params: [
      {
        name: "options",
        type: "{\n    /** A prompt or message shown to the user. */\n    message?: string;\n    /** If true and a point feature is already selected, return its coordinates without prompting. Defaults to true. */\n    preselect?: boolean;\n  }",
        optional: false,
        hasDefault: true,
      },
    ],
    returns: "Promise<GeoCoordinate | null>",
    doc: "Prompts the user to click on the map to place a point. The promise resolves with the geographic coordinate once the user clicks, or null if cancelled. Hold 's' to snap to nearby features.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "duplicateDrawingLayer",
    params: [
      { name: "layerNameOrId", type: "string", optional: false, hasDefault: false },
      { name: "newLayerNameOrId", type: "string", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Duplicates a drawing layer and its associated sections. Optionally specify a new name.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "duplicateScenario",
    params: [{ name: "scenario", type: "Scenario", optional: false, hasDefault: false }],
    returns: "Promise<Scenario | undefined>",
    doc: "Duplicate a scenario, creating a copy with all its features.",
    facts: { returnsNothing: false, asksUser: true },
  },
  {
    name: "enableBottomBarIframe",
    params: [
      { name: "url", type: "string", optional: false, hasDefault: false },
      { name: "height", type: "unknown", optional: false, hasDefault: true },
    ],
    returns: "unknown",
    doc: "Show a page from the app in a panel below the map.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "enableIsolateMode",
    params: [],
    returns: "unknown",
    doc: "Enables isolate mode.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "enableMapCamera",
    params: [],
    returns: "unknown",
    doc: "if called, the map camera will be dispatched to the SDK app on every map move and can be accessed via the state key `mapCamera`. Off until called. Each update carries the same value {@link getMapCamera} returns, debounced to the trailing edge of the move. An app that only needs the camera at the moment it draws can skip this and call {@link getMapCamera} instead, which is exempt from call throt...",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "enableMapContentEvents",
    params: [],
    returns: "unknown",
    doc: "if called, map content events (e.g. layer added, style updated, etc.) will be dispatched to the SDK app. By default this is enabled.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "enableMapHover",
    params: [{ name: "debounceTime", type: "unknown", optional: false, hasDefault: true }],
    returns: "unknown",
    doc: "if called, mouse coordinates will be dispatched to the SDK app and can be accessed via the state key `mapHoverCoords`.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "enterBlockEditMode",
    params: [{ name: "featureId", type: "FeatureId", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Opens the block editor on a block instance, exploding it into its child features so they can be edited in place. Call this again on a nested block instance to descend a level.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "enterGroupEditMode",
    params: [
      { name: "groupId", type: "string", optional: false, hasDefault: false },
      { name: "featureIds", type: "FeatureId[]", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Focuses a group so its members can be selected and edited individually, instead of clicking one selecting the whole group.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "evaluateFeatures",
    params: [
      { name: "features", type: "RawSection[]", optional: false, hasDefault: false },
      {
        name: "context",
        type: "Omit<ProjectBundle, 'bakedSectionsGroup'>",
        optional: true,
        hasDefault: false,
      },
      { name: "options", type: "{ stack?: false }", optional: true, hasDefault: false },
    ],
    returns: "Record<string, PreStackedSection[]>",
    doc: "Evaluates a set of raw sections against the current project state, producing pre-stacked sections keyed by feature ID. **Polygon winding:** Input polygon geometries must follow the [RFC 7946](https://datatracker.ietf.org/doc/html/rfc7946#section-3.1.6) right-hand rule — outer rings counter-clockwise, holes clockwise. The evaluator does not rewind input, and incorrectly-wound polygons may produc...",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "exitBlockEditMode",
    params: [{ name: "save", type: "unknown", optional: false, hasDefault: true }],
    returns: "boolean",
    doc: "Closes the block editor, writing the edited features back to the block definition when `save` is true and discarding them otherwise.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "exitGroupEditMode",
    params: [],
    returns: "unknown",
    doc: "Leaves group edit mode, so clicking a grouped feature selects its whole group again.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "featureArea",
    params: [
      { name: "feature", type: "StackedSection | any", optional: false, hasDefault: false },
      { name: "geoProject", type: "BasicConverter", optional: false, hasDefault: true },
    ],
    returns: "unknown",
    doc: "Calculate the area of a GeoJSON feature in square meters.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "fetchAppCredentials",
    params: [],
    returns: "unknown",
    doc: "Fetch credentials for an app.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "fetchContentPacks",
    params: [
      { name: "search", type: "string", optional: true, hasDefault: false },
      { name: "contents", type: "PackContentType[]", optional: true, hasDefault: false },
    ],
    returns: "Promise<PackFile[]>",
    doc: "Fetches all available content packs from the server.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "fetchCredentials",
    params: [],
    returns: "Promise<SharedCredential[]>",
    doc: "Fetch credentials that both the current user and the current app have access to. These are access tokens for third-party services (e.g. tile servers, AI APIs) that workspace admins have shared with this app.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "fetchPackContents",
    params: [{ name: "urlOrId", type: "string | number", optional: false, hasDefault: false }],
    returns: "Promise<PackContents>",
    doc: "Fetches the contents of a specific content pack by its URL or file ID.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "fetchProjectDetails",
    params: [{ name: "projectId", type: "string", optional: true, hasDefault: false }],
    returns: "Promise<ProjectDetails>",
    doc: "Fetches details (including project attachments) for a given project. This is also how you access a project's attachments — pair the returned `attachments` with `getTempUrl` to obtain publicly accessible URLs for each one.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "fetchProjectFiles",
    params: [],
    returns: "Promise<GiFileForDocs[]>",
    doc: "Fetches files for the user.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "fetchUserFiles",
    params: [],
    returns: "Promise<GiFileForDocs[]>",
    doc: "Fetches files for the user.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "fetchVistas",
    params: [{ name: "projectId", type: "string", optional: true, hasDefault: false }],
    returns: "Promise<View[]>",
    doc: "Fetches vistas for a project. Results are cached for 30 seconds, so a view saved since may be missing. `giraffeState.get('views')` is kept up to date.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "fetchWorkspaceDetails",
    params: [],
    returns: "Promise<SdkWorkspaceDetails | undefined>",
    doc: null,
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "fitBounds",
    params: [
      { name: "bounds", type: "LngLatBoundsLike", optional: false, hasDefault: false },
      { name: "options", type: "FlyToOptions", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Fit the map view to contain the specified bounds.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "flyTo",
    params: [{ name: "options", type: "FlyToOptions", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Animate the map camera to fly to a location. See Mapbox flyTo documentation for all options.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "fromProjected",
    params: [
      { name: "fc", type: "Feature | FeatureCollection", optional: false, hasDefault: false },
      { name: "origin", type: "[number, number]", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Convert local meter coordinates back to geographic coordinates (lng/lat). Reverses the toProjected transformation using the same origin point.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getAnalyticsResult",
    params: [],
    returns: "unknown",
    doc: "Get the analytics result for the current project.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getAppPanels",
    params: [],
    returns: "AppPanelState[]",
    doc: "Where every panel this app has open currently sits, and whether the user can see it. `rect` is in host-viewport pixels; it is `null` while the panel is not laid out. `active` means the panel's tab is the selected one in its group, `visible` means it is also not hidden behind a maximized panel. The same array is pushed on the `appPanels` state event whenever the layout changes, so prefer listeni...",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getBlock",
    params: [{ name: "blockId", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Returns the block definition for the given id, or undefined if not found.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getBlockEditStatus",
    params: [],
    returns: "BlockEditStatus",
    doc: "Reports the current block edit, if any. `blockIds` and `instanceIds` run outermost first, ending with the level being edited; `featureIds` are the exploded children of that level.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getBlocks",
    params: [],
    returns: "unknown",
    doc: "Returns all block definitions, keyed by id.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getFeatureState",
    params: [
      {
        name: "{\n  id,\n  source,\n  sourceLayer\n}",
        type: "{\n  id: string | number;\n  source: string;\n  sourceLayer?: string;\n}",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: "Get the current state of a Mapbox GL feature. This applies to features on Mapbox sources/layers, not Giraffe RawSections.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getFlowHandleNodeTypes",
    params: [],
    returns: "unknown",
    doc: "The flow node types that have an editable handle, for finding a feature to pass to {@link setFlowDrawingOverlay}.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getGeoTiff",
    params: [],
    returns: "unknown",
    doc: "Export the current 2D map view as a GeoTiff image. Only works when map is in 2D mode.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getGltf",
    params: [
      {
        name: "options",
        type: "{ keepInstancedMeshes?: boolean }",
        optional: true,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: "Export the current 3D scene as a GLTF model.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getGroupEditMode",
    params: [],
    returns: "string | null",
    doc: "The `groupID` currently being edited, or null when not in group edit mode.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getIsolateMode",
    params: [],
    returns: "string",
    doc: "Check if isolate mode is enabled.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getIsolatedFeatures",
    params: [],
    returns: "FeatureId[]",
    doc: "Get the currently isolated features.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getLassoShape",
    params: [],
    returns: "unknown",
    doc: "Prompt the user to draw a freehand lasso shape on the map. Disables the current draw tool and waits for user input. The promise resolves with the lasso shape, or undefined if cancelled.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getLassoedLensedFeatures",
    params: [],
    returns: "Promise<SDKLensable[]>",
    doc: "Prompt the user to draw a lasso and return all lensed features within the selection. Resolves with an empty array if the user cancels the lasso.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getLassoedProjectFeatures",
    params: [],
    returns: "Promise<RawSection[] | SDKLensable[]>",
    doc: "Prompt the user to draw a lasso and return all project features within the selection. Resolves with an empty array if the user cancels the lasso.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getLayerContents",
    params: [
      { name: "layerNameOrId", type: "string", optional: false, hasDefault: false },
      { name: "applyLensFilter", type: "unknown", optional: false, hasDefault: true },
      { name: "bounds", type: "FeatureCollection", optional: true, hasDefault: false },
      { name: "zoomIn", type: "number", optional: true, hasDefault: false },
      { name: "tilesIn", type: "Tile[]", optional: true, hasDefault: false },
    ],
    returns: "Promise<FeatureCollection>",
    doc: "Get the layer contents filtered by lens and extent of the provided bounds. All {z}/{x}/{y} tiles at zoomIn that intersect with bounds are used.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getLayerPermission",
    params: [{ name: "layerNameOrId", type: "string", optional: false, hasDefault: false }],
    returns: "Promise<'admin' | 'edit' | 'view'>",
    doc: "Get the current user's permission for a layer (layer must be added to the current project). NB Does not work for temp layers or portfolio layers as they share a project's permission.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getLensedFeatureMap",
    params: [],
    returns: "unknown",
    doc: "Get all features from the currently active lens layer as a Map. The lens is a filter/style panel that can be opened on any layer.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getMapBounds",
    params: [],
    returns: "unknown",
    doc: "Get the current map bounds as a GeoJSON FeatureCollection.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getMapCamera",
    params: [],
    returns: "MapCameraView",
    doc: "Get the camera position right now. see {@link enableMapCamera} and read the `mapCamera` state key to subscribe to the camera state.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getMapStyle",
    params: [],
    returns: "unknown",
    doc: "Get the current Mapbox style object.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getMapboxLayerIdsForLayer",
    params: [{ name: "nameOrId", type: "string", optional: false, hasDefault: false }],
    returns: "string[]",
    doc: "Resolve a layer name or full layer id to the list of mapbox style layer ids currently rendered for it on the map. A single Giraffe layer can produce multiple mapbox layers (fill + outline + symbol etc.), so this returns an array. Returns `[]` if the layer can't be resolved or none of its sub-layers are currently in the style. Accepts: - a `FullLayerId` from the layer tree (e.g. `\"GIRPLA-12345.0...",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getNode",
    params: [{ name: "id", type: "string", optional: false, hasDefault: false }],
    returns: "GiraffeNodeComponentBase",
    doc: "Returns the registered node definition for a given node instance id.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getParameterNode",
    params: [{ name: "nodeType", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Returns the parameter node associated with a generative transform node type.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getParameterNodeDefaultTransform",
    params: [{ name: "nodeType", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Returns the default transform object for a given generative transform node type.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getPng",
    params: [
      {
        name: "{\n  size,\n  rectangle\n}",
        type: "{ size?: { width: number; height: number }; rectangle?: Feature<Polygon> }",
        optional: false,
        hasDefault: true,
      },
    ],
    returns: "unknown",
    doc: "Export the current map view as a PNG image. Captures from this, {@link getPng2D} and {@link getPng3D} run one at a time, in the order they are called.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getPng2D",
    params: [
      {
        name: "options",
        type: "Pick<VistaCapture2D, '_viewBox' | 'size'>",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: "Render a 2D (top-down) PNG of an exact area of the map. The map switches to 2D and frames `_viewBox` for the capture, then returns to the user's camera and top view. A 2D view's `details` can be passed straight in. Captures run one at a time, in the order they are called.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getPng3D",
    params: [
      {
        name: "options",
        type: "Pick<VistaCapture3D, 'camera' | 'size'>",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: "Render a 3D (perspective) PNG of the map from a given camera. The map switches to 3D and moves to `camera` for the capture, then returns to the user's camera and top view. A 3D view's `details` can be passed straight in. Captures run one at a time, in the order they are called.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getProjectApp",
    params: [{ name: "appName", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: null,
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getProjectAttachmentPrompt",
    params: [
      { name: "formats", type: "FileTypeSubstring[]", optional: true, hasDefault: false },
      { name: "projectId", type: "string", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Open a file picker dialog for the user to upload a new project attachment. Project attachments are files that are shared with a project.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getProjectBundle",
    params: [{ name: "projectId", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Get the full project bundle including all sections, layers, and configuration. Prompts user for permission before loading project data.",
    facts: { returnsNothing: false, asksUser: true },
  },
  {
    name: "getProjectFlows",
    params: [],
    returns: "unknown",
    doc: "Returns all flows in the current project, keyed by their id.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getProjectUsages",
    params: [],
    returns: "unknown",
    doc: "Get all usage definitions for the current project. `getProjectUsages(): { [usageName: string]: Usage }`",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getProjects",
    params: [],
    returns: "ProjectFeatureCollection",
    doc: "Get all projects in the current workspace as a FeatureCollection.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getQueriedFeature",
    params: [],
    returns: "SDKLensable | RawSection",
    doc: "Get the feature currently under the user's mouse cursor (hovered) or last clicked.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getScenarioFeatures",
    params: [
      {
        name: "rawSections",
        type: "RawSection[] | Record<string, RawSection>",
        optional: false,
        hasDefault: false,
      },
      { name: "scenarioId", type: "string", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Get all features belonging to a specific scenario.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getScenarios",
    params: [],
    returns: "Record<string, Scenario>",
    doc: "Retrieves all scenarios for the current project. `getScenarios(): { [scenarioId: string]: Scenario }`",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getSdkRenderEnabled",
    params: [],
    returns: "boolean",
    doc: "Whether SDK-controlled rendering is currently enabled.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getSelectableProjectFeatures",
    params: [],
    returns: "RawSection[]",
    doc: "Get all project features that are currently selectable on the map. Filters out features on invisible or locked layers, hidden scenarios, and non-isolated features.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getSelectedFeatures",
    params: [],
    returns: "unknown",
    doc: "Returns the (raw) Giraffe features that are currently selected",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getSourceLayerDetails",
    params: [{ name: "term", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "get layer info to pass to `getVectorLayerContents` from a layer in the base style eg `roads`",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getTeamList",
    params: [],
    returns: "unknown",
    doc: "Get the list of teams in the current organization.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getTempUrl",
    params: [{ name: "storageProxyUrl", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "get a temporary (valid for 60s) URL to access resources (files, content library packs, project attachments, etc.). Works for urls of the form /api/storage-proxy/...",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getTerrainMeshes",
    params: [],
    returns: "unknown",
    doc: "Get the terrain meshes as a JSON string.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getTiles",
    params: [
      { name: "fc", type: "FeatureCollection", optional: false, hasDefault: false },
      { name: "zoom", type: "unknown", optional: false, hasDefault: true },
      { name: "radius", type: "unknown", optional: false, hasDefault: true },
    ],
    returns: "FeatureCollection<Geometry, Feature['properties'] & Tile['properties']>",
    doc: "get the tile bounding boxes at a given zoom level covering the provided fc, used to start a GIS pipeline eg query or join per tile",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getUrlParams",
    params: [],
    returns:
      "{\n  // the workspace the user is currently in\n  activeWorkspace: string | undefined;\n  // the project the user is currently in\n  activeProject: string | undefined;\n  auditMode: 'work' | 'audit' | 'embed' | 'view' | undefined;\n  pathname: string;\n  host: string;\n  queryParams: string;\n}",
    doc: "Get the current page URL and Giraffe routing context. Returns the active workspace, project, and mode along with URL details.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getUsage",
    params: [{ name: "usageName", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Get a single usage definition by name. `getUsage(usageName: string): Usage`",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getUserClaimsJwt",
    params: [{ name: "projectIds", type: "string[]", optional: true, hasDefault: false }],
    returns: "Promise<string>",
    doc: "Fetches a signed JWT (RS256) encoding the current user's claims. The JWT's decoded payload has the shape: ```ts { exp: number; user_id: number; user_name: string; user_email: string; app: { app_id: number; app_name: string }; workspaces: { workspace_id: number; workspace_name: string; access_level: string; workspace_type: string }[]; teams: { team_id: number; team_name: string; access_level: st...",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getUserData",
    params: [{ name: "appId", type: "string", optional: false, hasDefault: false }],
    returns: "Promise<Record<string, unknown>>",
    doc: "Gets the current user's meta data for a specific app.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getUserDrawnLineString",
    params: [],
    returns: "Promise<GeoJsonLineString | undefined>",
    doc: "Prompt the user to draw a line on the map. The promise resolves once the user completes the line (double-click or Enter), or undefined if cancelled. Hold 's' to snap to nearby features.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getUserDrawnPoint",
    params: [],
    returns: "Promise<GeoJsonPoint | undefined>",
    doc: "Prompt the user to place a point on the map. The promise resolves once the user clicks to place the point, or undefined if cancelled. Hold 's' to snap to nearby features.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getUserDrawnPolygon",
    params: [],
    returns: "Promise<GeoJsonPolygon | undefined>",
    doc: "Prompt the user to draw a polygon on the map. The promise resolves once the user completes the polygon, or undefined if cancelled. Hold 's' to snap to nearby features.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getVectorLayerContents",
    params: [
      { name: "url", type: "string", optional: false, hasDefault: false },
      { name: "sourceLayer", type: "string", optional: false, hasDefault: false },
      { name: "tiles", type: "Tile[]", optional: false, hasDefault: false },
    ],
    returns: "Promise<FeatureCollection>",
    doc: "Get the contents of a vector tile layer as GeoJSON.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "getVisibleScenarios",
    params: [],
    returns: "Scenario[]",
    doc: "Gets the currently visible scenarios. `getVisibleScenarios(): Scenario[]`",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "importRawSections",
    params: [
      { name: "features", type: "RawSection[]", optional: false, hasDefault: false },
      {
        name: "{\n      featureCategories,\n      ...others\n    }",
        type: "{\n      featureCategories?: GiraffeFeatureCategories;\n      flows?: GiraffeNodeGraph[];\n      blocks?: BlockDefinition[];\n      insertionPoint?: GeoCoordinate;\n      keepLayerIds?: boolean;\n      decisionType?: DecisionType;\n    }",
        optional: false,
        hasDefault: true,
      },
    ],
    returns: "unknown",
    doc: "Import RawSections into the current project, with options for usages, flows, etc. See the return type of `getProjectBundle`",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "insertBlock",
    params: [
      { name: "blockId", type: "string", optional: false, hasDefault: false },
      { name: "message", type: "string", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Prompts the user to click the map to place an instance of a block. Creates a Point feature with the block's id, which Giraffe renders as the block's geometry. To place blocks at known coordinates without a map click, pass an array of Point features with a `blockId` property to {@link createRawSections}. It does not validate `blockId`, so confirm the block exists with {@link getBlock} first. Opt...",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "listHostedApps",
    params: [],
    returns: "Promise<HostedApp[]>",
    doc: "List the apps that Giraffe hosts in the current workspace and that you administer, including every app you made with {@link createApp}.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "loadImage",
    params: [
      { name: "url", type: "string", optional: false, hasDefault: false },
      { name: "key", type: "string", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Load an image from a URL to mapbox, the key of which can be further referenced by styles. see https://docs.mapbox.com/style-spec/reference/layers/#layout-symbol-icon-image returns a promise that resolves to the image key (string) when loaded or null if loading failed",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "moveLayerTreeItemIntoGroup",
    params: [
      { name: "itemId", type: "string", optional: false, hasDefault: false },
      { name: "groupId", type: "string", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Move an item into a group.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "navigateTo",
    params: [{ name: "url", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Navigate to a different page. Can be used to switch project, or navigate to a different page in Giraffe. If it is a different origin to Giraffe, the URL needs to be whitelisted by us for security reasons. Contact us for details.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "openAppPanel",
    params: [{ name: "options", type: "OpenAppPanelOptions", optional: false, hasDefault: true }],
    returns: "unknown",
    doc: "Open a second view of the calling app in its own panel, anchored to an existing panel. The panel runs the same app in a fresh iframe. It receives the same state events and can call the same RPC functions. The panel URL must be same-origin with the app; omit it to reuse the app's own URL. These panels are never written into a saved layout, and they close with the app. Once open, track where the ...",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "openProject",
    params: [{ name: "projectId", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Open a project in a new browser tab.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "patchProperties",
    params: [
      { name: "projects", type: "ProjectFeatureCollection", optional: false, hasDefault: false },
      {
        name: "newProps",
        type: "(f: Feature) => Record<string, number | string | boolean>",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: "Patch properties on multiple projects.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "pickRawSections",
    params: [
      {
        name: "options",
        type: "{\n    /** A prompt or message shown to the user. */\n    message?: string;\n    /** The geometry type(s) that can be selected. Combine with bitwise OR for multiple types. */\n    filter?: number;\n    /** Honor object grouping. If true and the user picks a grouped feature, the entire group is selected. */\n    group?: boolean;\n    /** Allow pre-selected features to be returned without prompting. Defaults to true. */\n    preselect?: boolean;\n    /** Minimum number of features required before the selection can be confirmed. */\n    minimumCount?: number;\n    /** If true, the user can shift-click or shift-drag to select multiple features. */\n    multiselect?: boolean;\n    /** A custom filter function to further restrict which features are selectable. */\n    customFilter?: (feature: RawSection) => boolean;\n  }",
        optional: false,
        hasDefault: true,
      },
    ],
    returns: "Promise<RawSection[]>",
    doc: "Prompts the user to pick one or more raw sections from the map. The promise resolves once the user confirms their selection (click or Enter).",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "queryRenderedFeatures",
    params: [
      { name: "lngLat", type: "LngLatLike", optional: true, hasDefault: false },
      {
        name: "options",
        type: "{ layers?: string[] | undefined; filter?: any[] | undefined } & { [key: string]: any }",
        optional: true,
        hasDefault: false,
      },
      { name: "pixBuffer", type: "unknown", optional: false, hasDefault: true },
    ],
    returns: "(Feature & { layerId?: string })[]",
    doc: "base on https://docs.mapbox.com/mapbox-gl-js/api/map/#map#queryrenderedfeatures",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "readyToClose",
    params: [],
    returns: "unknown",
    doc: "Signal that the SDK app is ready to close. Should be called after receiving the closingSignal from giraffeState.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "removeFeatureState",
    params: [
      {
        name: "{\n  id,\n  source,\n  sourceLayer\n}",
        type: "{\n  id?: string | number;\n  source: string;\n  sourceLayer?: string;\n}",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: "Remove previously set state from a Mapbox GL feature. This applies to features on Mapbox sources/layers, not Giraffe RawSections.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "removeLayerFromProject",
    params: [{ name: "layerId", type: "string | number", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Removes a layer from the project",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "removeLayerGroup",
    params: [{ name: "groupName", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Remove a group from the layer tree. Layers in the group will be moved out, but not deleted.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "removeLayers",
    params: [{ name: "layerNamesOrIds", type: "string[]", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Delete drawing and project layers. Sections on the drawing layers are deleted too",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "removeMapboxEventListener",
    params: [{ name: "listenerId", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Remove a previously added Mapbox event listener.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "removeTempLayer",
    params: [{ name: "layerName", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Remove a temporary layer from the map.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "renameDrawingLayer",
    params: [
      { name: "layerNameOrId", type: "string", optional: false, hasDefault: false },
      { name: "newLayerNameOrId", type: "string", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Renames an existing drawing layer and updates all associated sections and analytics references.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "renameLayerGroup",
    params: [
      { name: "groupName", type: "string", optional: false, hasDefault: false },
      { name: "newGroupName", type: "string", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Rename a group in the layer tree",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "renameScenario",
    params: [
      { name: "scenarioId", type: "string", optional: false, hasDefault: false },
      { name: "newName", type: "string", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Renames a scenario. `renameScenario(scenarioId: string, newName: string): void`",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "reorderLayerTreeItem",
    params: [
      { name: "sourceId", type: "string", optional: false, hasDefault: false },
      { name: "destinationId", type: "string", optional: false, hasDefault: false },
      { name: "reorderBelow", type: "unknown", optional: false, hasDefault: true },
    ],
    returns: "unknown",
    doc: "Reorder any layer tree item or group.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "resetLayerLens",
    params: [{ name: "layerNameOrId", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Clear the saved lens (style, filters and property definitions) from a layer",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "selectProjectAttachmentPrompt",
    params: [
      { name: "fileFormats", type: "FileTypeSubstring[]", optional: true, hasDefault: false },
      { name: "projectId", type: "string", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Open a dialog for the user to select from existing project attachments.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "setContextMenuItems",
    params: [{ name: "items", type: "string[]", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Set custom context menu items that appear on right-click.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setDrawTool",
    params: [{ name: "tool", type: "DrawTool", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Set the active drawing tool for map interactions.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setDrawingLayerLocked",
    params: [
      { name: "layerNameOrId", type: "string", optional: false, hasDefault: false },
      { name: "locked", type: "unknown", optional: false, hasDefault: true },
    ],
    returns: "unknown",
    doc: "Locks or unlocks an existing drawing layer Like visibility and opacity, this applies to the session and is written to the backend when the layer tree is next saved.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setFeatureState",
    params: [
      {
        name: "{\n    id,\n    source,\n    sourceLayer\n  }",
        type: "{\n    id: string | number;\n    source: string;\n    sourceLayer?: string;\n  }",
        optional: false,
        hasDefault: false,
      },
      { name: "props", type: "Record<string, any>", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Set arbitrary state on a Mapbox GL feature. This applies to features on Mapbox sources/layers (e.g. tilesets, GeoJSON sources), not Giraffe RawSections. To modify Giraffe features, use `updateRawSection` instead.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setFlowDrawingOverlay",
    params: [
      { name: "overlay", type: "SdkDrawOverlay | null", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Open the drawing overlay for a flow block. Equivalent to a user pressing shift+A. Selects the feature if it isn't already, and enters vertices edit mode. Pass null to close the overlay and leave that mode again.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setHighlightedFeatures",
    params: [
      { name: "features", type: "Feature[]", optional: false, hasDefault: false },
      { name: "color", type: "number", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Set the highlighted features on the map.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setIsolatedFeatures",
    params: [{ name: "featureIds", type: "FeatureId[]", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Set the features that should be isolated in isolate mode. Enables isolate mode if not already enabled.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setLayerGroupExpanded",
    params: [
      { name: "groupName", type: "string", optional: false, hasDefault: false },
      { name: "expanded", type: "boolean", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Expand or collapse a group in the layer tree",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setLayerStyleByLens",
    params: [
      { name: "layerNameOrId", type: "string", optional: false, hasDefault: false },
      { name: "styleByLens", type: "boolean", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Choose whether a layer draws itself from its saved lens or from its own style. `updateLayerStyle` sets this implicitly whenever the style it is given holds a display key; use this to control it on its own.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setMapCamera",
    params: [{ name: "camera", type: "Partial<MapCamera>", optional: false, hasDefault: true }],
    returns: "MapCameraView",
    doc: "Move the map, and take back where it landed. Exempt from call throttling.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "setScenarioVisibility",
    params: [
      { name: "visibilities", type: "Record<string, boolean>", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Sets the visibility of scenarios. `setScenarioVisibility(visibilities: { [scenarioId: string]: boolean }): void`",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setSdkRender",
    params: [
      { name: "config", type: "SdkRenderOverrides | null", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Take control of what the map renders. Pass an overrides object to enable SDK-controlled rendering, or `null` to disable it (features are restored to their project state). The overrides can hide existing features, override an existing feature's baked properties/geometry, and add new baked features. Extra/overridden geometry must be supplied as fully-baked sections — the same shape received via t...",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setSelectedFeatures",
    params: [{ name: "features", type: "rawSectionId[]", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Set the selected features by their IDs.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setTiles",
    params: [
      { name: "sourceId", type: "string", optional: false, hasDefault: false },
      { name: "tiles", type: "string[]", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Can be used by an app to override the source of a vector tile layer",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setTopView",
    params: [{ name: "view", type: "'2D' | '3D'", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Set the map camera mode to flat 2D or perspective 3D. In 2D mode the camera looks straight down. In 3D mode the camera has pitch and allows tilting.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "setUserData",
    params: [{ name: "data", type: "Record<string, unknown>", optional: false, hasDefault: false }],
    returns: "Promise<void>",
    doc: "Sets the current user's meta data for a specific app. Rate limited to 1 request per 10 seconds.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "shareWithTeam",
    params: [
      { name: "teamName", type: "string", optional: false, hasDefault: false },
      { name: "projects", type: "ProjectFeatureCollection", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Share projects with a team. Creates the team if it doesn't exist.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "soloScenario",
    params: [{ name: "scenarioId", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Solo a scenario, hiding all other scenarios and showing only the specified one.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "stackFeatures",
    params: [{ name: "features", type: "PreStackedSection[]", optional: false, hasDefault: false }],
    returns: "StackedSection[]",
    doc: "Resolve stacking (_baseHeight, _height, _stackOrder) for pre-stacked sections by overlap and stackOrder. A feature hidden by a layer toggle or an inactive scenario is skipped by the stacking pass, so `_isBaseSection`, `_stackOrder` and `_isTopOfStack` are absent on it. `_buildingID` falls back to its own `buildingID` (or stays unset), and `_baseHeight` / `_height` describe it standing alone on ...",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "switchLayout",
    params: [{ name: "layout", type: "string", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Switch to another of the project's saved layouts, the same as clicking its tab in the layout bar. Unlike `updateLayout`, this leaves every layout as it is and only changes which one is shown. Switching to the layout that is already shown does nothing. List the project's layouts, in tab order, from `giraffeState.get('uiLayout').layouts`. The one currently shown is `giraffeState.get('uiLayout').p...",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "syncToProjects",
    params: [
      { name: "fc", type: "ProjectFeatureCollection", optional: false, hasDefault: false },
      { name: "idGetter", type: "(f: Project) => string", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Useful to bulk sync a list of projects/geometries from outside of Giraffe and make corresponding projects in Giraffe. **Use With Caution!** This can create many duplicate projects if used incorrectly.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "toProjected",
    params: [
      { name: "fc", type: "Feature | FeatureCollection", optional: false, hasDefault: false },
      { name: "origin", type: "[number, number]", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Convert geographic coordinates (lng/lat) to local meters relative to an origin point. Useful for CAD-style operations where you need to work in metric units.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "toggleLensLayer",
    params: [
      { name: "layerNameOrId", type: "string", optional: false, hasDefault: false },
      {
        name: "overrides",
        type: "Partial<GiraffeLensableStyle>",
        optional: true,
        hasDefault: false,
      },
      { name: "uiOverrides", type: "Partial<LensUiState>", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Activate the lens for a layer.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "updateApp",
    params: [
      { name: "id", type: "number", optional: false, hasDefault: false },
      { name: "options", type: "UpdateAppOptions", optional: false, hasDefault: false },
    ],
    returns: "Promise<HostedApp>",
    doc: "Change the page, name or logo of an app that Giraffe hosts in the current workspace. Use this to republish, rather than calling {@link createApp} again. Changing the page needs an active Enterprise license on the workspace. You need edit access to the app.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "updateBlock",
    params: [
      { name: "blockId", type: "string", optional: false, hasDefault: false },
      {
        name: "updatedBlock",
        type: "Partial<BlockDefinition>",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: "Updates an existing block definition by merging the provided fields. The block's id cannot be changed.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "updateFlowDags",
    params: [
      {
        name: "dags",
        type: "Record<string, GiraffeNodeGraph>",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: null,
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "updateFlows",
    params: [
      {
        name: "flows",
        type: "Record<string, GiraffeNodeGraph>",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: "Updates flows by id.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "updateGeoJSONLayerContents",
    params: [
      { name: "layerName", type: "string", optional: false, hasDefault: false },
      { name: "fc", type: "FeatureCollection", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Utility wrapper this uploads the geojson fc then calls patchLayer if layerName exists, otherwise createLayer then addProjectLayer.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "updateLayer",
    params: [
      {
        name: "layerPatch",
        type: "Omit<LayerPatch, 'vector_source'>",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: "Update a layer's configuration (excluding vector source).",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "updateLayerStyle",
    params: [
      { name: "layerNameOrId", type: "string", optional: false, hasDefault: false },
      { name: "style", type: "Partial<GiraffeLensableStyle>", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Update the style of a layer.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "updateLayerTreeVisibility",
    params: [{ name: "layerTree", type: "LayerTree", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Apply the visibility, opacity and (for groups) `enabled` state of a layerTree to the map. Use this to write back a tree you have read from `giraffeState.get('layerTree')` and edited — for example after toggling a group's `enabled` flag or a layer's `visible`/`opacity`. Layer order and tree structure (adding/removing items) are not changed; only per-item state is applied.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "updateLayout",
    params: [
      { name: "root", type: "PanelNode", optional: false, hasDefault: false },
      { name: "visibility", type: "LayoutBarVisibility", optional: true, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Replace the panel tree of the active layout, and optionally show or hide its bars. The layout's name and colour are preserved. A leaf holds tabs (`apps`) and marks one of them active. A split divides its `children` by relative `sizes` — `direction: 'v'` lays them out left to right, `'h'` stacks them top to bottom. Every `id` must be unique within the tree and no longer than 8 characters. Unknow...",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "updateProject",
    params: [{ name: "feature", type: "Project", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Update a project's geometry or properties.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "updateProjectApp",
    params: [
      { name: "appId", type: "string", optional: false, hasDefault: false },
      { name: "cloned", type: "ProjectApp", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Update a project app configuration.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "updateRawSection",
    params: [
      {
        name: "feature",
        type: "{\n  geometry?: RawSection['geometry'];\n  properties: { id: string } & Partial<RawSectionProps>;\n}",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: "Update an existing `RawSection`. Supports **partial updates** — only pass the properties you want to change. The `id` field must be set in `properties` to identify which section to update. The function merges your changes with the existing section: geometry is replaced only if provided, and properties are shallow-merged (your values overwrite existing ones, unmentioned properties are kept). Pas...",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "updateRawSections",
    params: [
      {
        name: "features",
        type: "{ geometry?: RawSection['geometry']; properties: { id: string } & Partial<RawSectionProps> }[]",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: "Same as `updateRawSection` but for many features. Partial updates are supported for each feature, but each must have `properties.id` to identify which section to update. Pass `null` for a property value to delete it.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "updateTempLayerGeoJSON",
    params: [
      { name: "layerName", type: "string", optional: false, hasDefault: false },
      { name: "fc", type: "FeatureCollection", optional: false, hasDefault: false },
      { name: "clearExisting", type: "unknown", optional: false, hasDefault: true },
    ],
    returns: "unknown",
    doc: "update temporary layer data",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "updateUiLayout",
    params: [{ name: "layout", type: "SdkUiLayout", optional: false, hasDefault: false }],
    returns: "unknown",
    doc: "Update UI layout settings (lens table, overlays). See {@link SdkUiLayout} for available fields. The `bottomBarIframe` option is deprecated: use openAppPanel instead. Support will be removed in a future version.",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "updateUsage",
    params: [
      { name: "usageName", type: "string", optional: false, hasDefault: false },
      { name: "updates", type: "Partial<Usage>", optional: false, hasDefault: false },
    ],
    returns: "unknown",
    doc: "Update an existing usage definition. Accepts a partial — only the fields you provide will be merged into the existing usage. Set a field to `null` to remove it. `updateUsage(usageName: string, updates: Partial<Usage>): void` The `updates` object must use the nested Usage structure. Properties go inside `default` or `join`, never at the top level: ```typescript // CORRECT — floorToFloor inside j...",
    facts: { returnsNothing: true, asksUser: false },
  },
  {
    name: "updateWorkspaceDetails",
    params: [
      {
        name: "patch",
        type: "{\n      settings?: Partial<SdkWorkspaceDetails['settings']>;\n      properties?: SdkWorkspaceDetails['properties'];\n    }",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "Promise<SdkWorkspaceDetails | undefined>",
    doc: "NB `settings` is shallow-merged with the existing settings; `properties` is replaced wholesale when provided.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "uploadProjectAttachment",
    params: [
      {
        name: "options",
        type: "UploadProjectAttachmentOptions",
        optional: false,
        hasDefault: false,
      },
    ],
    returns: "unknown",
    doc: "Upload a file as a project attachment.",
    facts: { returnsNothing: false, asksUser: false },
  },
  {
    name: "validateLensStyle",
    params: [{ name: "style", type: "unknown", optional: false, hasDefault: false }],
    returns: "LensStyleValidationResult",
    doc: "Validates a {@link GiraffeLensableStyle} object at runtime. Not every field on the type is checked — this targets the fields most commonly misconfigured by SDK callers.",
    facts: { returnsNothing: false, asksUser: false },
  },
];

/** Every registered host RPC, by name, with the signature it was declared with. */
export const HOST_RPC_SIGNATURES: ReadonlyMap<string, HostRpcSignature> = new Map(
  SIGNATURES.map((signature) => [signature.name, signature]),
);

/** How many required positional parameters `name` declares. */
export function requiredArity(signature: HostRpcSignature): number {
  return signature.params.filter((p) => !p.optional && !p.hasDefault).length;
}
